import gql from 'graphql-tag';

export default gql`
    mutation activateDistrict($input: ActivateDistrictInput) {
        activateDistrict(input: $input) {
            status
        }
    }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/go-live/components/ActivateDistrict.mutation.js